import { toast } from 'sonner';
import { getApiErrorMessage } from './apiError';

interface ProcessErrorOptions {
  /** Fallback zpráva, když z chyby nejde vytáhnout nic smysluplného. */
  fallback?: string;
  /** Když true, toast se nezobrazí (jen se vrátí zpracovaná data). */
  silent?: boolean;
  /** Volitelný titulek toastu; zpráva se pak zobrazí jako description. */
  title?: string;
}

interface ProcessedError {
  message: string;
  /** Field-level chyby pro formuláře (Formik/Yup setErrors). */
  details?: Record<string, string[] | string>;
  errorCode?: string;
  traceId?: string;
}

/**
 * Centrální zpracování API chyby dle interního standardu (RFC 9457).
 * Vytáhne message / errorCode / traceId / details, zaloguje traceId pro support
 * a (pokud není silent) zobrazí právě jeden sonner toast.
 */
export const processError = (error: unknown, opts: ProcessErrorOptions = {}): ProcessedError => {
  const data = (error as any)?.response?.data ?? {};
  const message = getApiErrorMessage(error, opts.fallback ?? 'Něco se pokazilo');
  const { errorCode, traceId, details } = data;

  if (traceId || errorCode) {
    // eslint-disable-next-line no-console
    console.error('[API error]', { traceId, errorCode, message });
  }

  if (!opts.silent && message?.trim()) {
    if (opts.title) {
      toast.error(opts.title, { description: message });
    } else {
      toast.error(message);
    }
  }

  return { message, details, errorCode, traceId };
};
